<template>
	<div class="wrapper">
		<BalanceInfo :title="title" show-switch-account :show-balance="showBalance" />

		<div class="murk">
			<div class="maintenance-purchase">
				<img src="~@/images/purchase-maintenance.png" alt="" />

				<div class="maintenance-purchase__header">
					<div class="maintenance-purchase__header__title">
						{{ $t('checkout.maintenance.title') }}
					</div>
					<div class="maintenance-purchase__header__message">
						<i18n path="checkout.maintenance.desc" tag="p">
							<template v-slot:breakLine>
								<br />
							</template>
						</i18n>
					</div>
				</div>

				<div v-if="maintenancePeriod" class="maintenance-purchase__details">
					{{ maintenancePeriod }}
				</div>

				<div class="maintenance-purchase__divider" />

				<div class="maintenance-purchase__contacts">
					<i18n path="checkout.maintenance.contact" tag="p">
						<template v-slot:maintenanceContactLinkText>
							<a v-t="'checkout.maintenance.contact-link-text'" :href="supportLink" target="_blank"></a>
						</template>
					</i18n>
				</div>

				<div class="maintenance-purchase__action">
					<FormButton
						class="btn-primary"
						:label="$t('checkout.confirmation')"
						:button-click="buttonAction"
					></FormButton>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BalanceInfo from '@/components/common/balance-info';
import { FormButton } from '@arena/toolkit';
import config from '@/config/environment-config';
import links from '@/config/links';

export default {
	name: 'PurchaseMaintenance',
	components: {
		BalanceInfo,
		FormButton,
	},
	computed: {
		showBalance() {
			if (this.region === 'tw' && this.$store.state.appType === 'game') {
				return false;
			}
			return true;
		},
		title() {
			if (this.region === 'global') {
				return this.$t('checkout.buy-nx');
			}

			if (this.region === 'tw' && this.$store.state.appType === 'game') {
				return this.$t('checkout.maintenance.add-balance');
			}

			return this.$t('add-balance');
		},
		supportLink() {
			return links['tw'].supportLink;
		},
		maintenancePeriod() {
			const { maintenanceStartDate, maintenanceEndDate } = this.$store.state.selectedPg || {};

			const from = this.convertStringToDate(maintenanceStartDate);
			const to = this.convertStringToDate(maintenanceEndDate);

			if (this.isValidDate(from) && this.isValidDate(to)) {
				return `${this.convertDateToString(from)} ~ ${this.convertDateToString(to)}`;
			} else if (this.isValidDate(from)) {
				return `${this.convertDateToString(from)} ~ `;
			} else if (this.isValidDate(to)) {
				return ` ~ ${this.convertDateToString(to)}`;
			}

			return null;
		},
	},
	methods: {
		isValidDate(date) {
			return !isNaN(date);
		},
		convertStringToDate(ds) {
			if (!ds) return undefined;

			return ds.toLowerCase().endsWith('z') ? new Date(ds) : new Date(ds + 'Z');
		},
		convertDateToString(date) {
			const utc8Offset = 8 * 60;
			const localOffset = date.getTimezoneOffset();
			const utc8Date = new Date(date.getTime() + (utc8Offset + localOffset) * 60 * 1000);

			const year = utc8Date.getFullYear();
			const month = `${utc8Date.getMonth() + 1}`.padStart(2, '0');
			const day = `${utc8Date.getDate()}`.padStart(2, '0');
			const hours = `${utc8Date.getHours()}`.padStart(2, '0');
			const minutes = `${utc8Date.getMinutes()}`.padStart(2, '0');

			return `${year}.${month}.${day} ${hours}${this.$t('checkout.hour')}${minutes}${this.$t(
				'checkout.minute'
			)}(UTC+8)`;
		},
		buttonAction() {
			if (this.$store.state.appType === 'game') {
				window.close();
			} else if (this.returnURL) {
				this.goto(this.returnURL);
			} else {
				window.location.href = `${config[process.env.VUE_APP_ENV][environment.region].wallet}/${
					this.$i18n.locale
				}/add-balance`;
			}
		},
	},
};
</script>
<style lang="less" scoped>
.maintenance-purchase {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	max-width: 640px;
	margin-top: 50px;
	margin-left: auto;
	margin-right: auto;

	& img {
		width: fit-content;
		margin-bottom: 40px;
	}

	&__header {
		flex: 0 0 100%;
		font-size: 24px;
		text-align: center;
		margin-bottom: 36px;

		&__title {
			color: #fff;
			font-weight: bold;
			line-height: normal;
			margin-bottom: 8px;
		}
		&__message {
			color: rgba(255, 255, 255, 0.8);
			font-size: 14px;
			line-height: 18px;
		}
	}

	&__details {
		color: #ff1744;
		margin-bottom: 36px;
	}

	&__divider {
		width: 100%;
		height: 2px;
		background-color: rgba(255, 255, 255, 0.5);
		margin-bottom: 32px;
	}

	&__contacts {
		opacity: 0.5;
		color: #fff;
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
		margin-bottom: 36px;

		a {
			text-decoration: underline;
			text-underline-position: under;
			text-transform: capitalize;
			color: inherit;
			&:hover {
				color: #fff;
			}
		}
	}

	&__action {
		display: flex;
		flex-wrap: wrap;
		flex: 0 0 100%;
		max-width: 100%;
		justify-content: center;
		button {
			min-width: 320px;
			width: auto;
			margin-top: 26px;
		}
	}
}
</style>
